import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Rx";

@Injectable()
export class SlackApi {

    private API_ROOT:string = '/slack';

    constructor(private http: Http) {}

    getUsernameById (id): Observable<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('slackId', id);

        return this.http.get(`${this.API_ROOT}/usernames`, new RequestOptions({
            search: params
        })).map(r => r.json());
    }

    getMentions (): Observable<any> {
        return this.http.get(`${this.API_ROOT}/mentions`).map(r => r.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/slack-api/slack-api.component.ts